import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./ContactDetailsForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelChangeContactDetails} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "email");
  return errors.toJS();
}

class ChangeContactDetailsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changeContactDetails(values.set("customerId", this.props.customerId).toJS())
      .then((response) => {
        if (response.data.changeContactDetails.errors.length <= 0) {
          this.props.cancelChangeContactDetails();
        } else {
          let errors = createValidationErrors(response.data.changeContactDetails.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeContactDetails();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS(data.customer).delete("__typename");
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CUSTOMER = gql`
  query customer($customerId: ID!) {
    customer(customerId: $customerId) {
      name
      email
      phone
    }
  }
`;

const CHANGE_CONTACT_DETAILS = gql`
  mutation changeContactDetails($data: CartPoliciesInput!) {
    changeContactDetails(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CUSTOMER, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        customerId: props.customerId
      }
    })
  }),
  graphql(CHANGE_CONTACT_DETAILS, {
    props: ({ mutate }) => ({
      changeContactDetails: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelChangeContactDetails})(withQueries(ChangeContactDetailsFormContainer));